import { useRef } from "react";
import { Form } from "react-bootstrap";
import { Upload, Eye } from "lucide-react";
import { toastMsg } from "./toast";



function UploadFile(props) {

    const {
        title = 'Upload JD',
        accept = '.pdf,.doc,.docx',
        fileType = 'base64',
        handleFile,
        maxSizeMB = 5,
        fileName = '',
        fileData = '',
        isDisabled = false,
        handlePreview
    } = props

    const uplaodFileRef = useRef()

    const canPreview = Boolean(fileName && fileData)

    

    const handleClickUplaod = () => {
        if (isDisabled) return;
        uplaodFileRef.current.click()
    }

    const handleUploadFile = (e) => {

        const file = e.target.files[0];
        if (!file) return;

        if (file.size > maxSizeMB * 1024 * 1024) {
            toastMsg("error", `File size must be less than ${maxSizeMB} MB`);
            e.target.value = "";
            return;
        }


        const name = file.name;

        if (fileType === 'base64') {
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = reader.result;
                handleFile(base64, name)
            };
            reader.readAsDataURL(file);
        }

        e.target.value = "";
    };

    return (
        <>
            <input type="file"
                style={{ display: 'none' }}
                ref={uplaodFileRef}
                accept={accept}
                onChange={handleUploadFile}
            />
            <div
                className="position-relative"
                style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
                onClick={handleClickUplaod}
            >
                <Form.Control
                    type="text"
                    readOnly
                    placeholder={title}
                    value={fileName || ""}
                    title={fileName || title}
                    className="input-text-14 font-size-h4"
                    style={{
                        paddingRight: canPreview ? "60px" : "34px",
                        cursor: "inherit",
                        backgroundColor: "transparent",
                        textOverflow: "ellipsis",
                    }}
                />

                {canPreview && (
                    <Eye
                        size={16}
                        onClick={()=>handlePreview(fileData)}
                        title="Preview file"
                        style={{
                            position: "absolute",
                            right: "38px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#6c757d",
                            cursor: "pointer",
                        }}
                    />
                )}

                <Upload
                    size={16}
                    style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#6c757d",
                        pointerEvents: "none",
                    }}
                />
            </div>
        </>
    )

}

export default UploadFile
